module.exports = __webpack_public_path__ + "img/icon-authorization-over.349c19a7.svg";